import { PropsWithChildren } from "react";
import {
  flexColumns,
  fullWidthContainer,
  layout,
  mainContainer,
} from "./styles.css";

export const PageLayout = ({ children }: PropsWithChildren) => {
  return <div className={layout}>{children}</div>;
};

export const Section = ({ children }: PropsWithChildren) => {
  return <div className={mainContainer}>{children}</div>;
};

export const FullWidthSection = ({ children }: PropsWithChildren) => {
  return <div className={fullWidthContainer}>{children}</div>;
};

export const FlexColumns = ({ children }: PropsWithChildren) => {
  return <div className={flexColumns}>{children}</div>;
};
